import { Input, KeyCode } from "../../../lib/Input";
import Ability from "../../Ability";
import Player from "../../Player";

export default class BoostThrusters extends Ability {

    constructor(player: Player) {
        super(player, {
            cooldown: 12,
            duration: 4,
            energyCost: 15,
            icon: 9,
            trigger: KeyCode.Digit1,
            triggerType: Input.GetKeyDown,
            info: `Boost Thruster (12s cooldown) - for 4 seconds, overcharge your thrusters, increasing max speed and acceleration`
        })
    }

    onDurationEnd(): void {
        this.player.accelerationForce = 125;
    }

    onUse(): void {
        this.player.accelerationForce = 200;
    }
}